// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { useTheme } from "../../contexts/theme";
import { ReactComponent as ApplicationLogo } from "./logo.svg";
import { ReactComponent as SegurosUnimedLogo } from "./segurosUnimedLogo.svg";

const logos = {
  segurosUnimed: <SegurosUnimedLogo />,
  default: <ApplicationLogo />,
};

export const Logo = () => {
  const { theme } = useTheme();
  return logos[theme] || logos.default;
};
